export const NAME = 'apps';

export const DECLINED_STATUS = 'declined';
